import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from '@angular/core';
import { AvatarService } from '@iupics-components/standard/user/avatar-ui/avatar-service/avatar.service';
import { AvatarFullInfos, AvatarInfos } from '@iupics-manager/models/user-account';

@Component({
  selector: 'iu-avatar-ui',
  templateUrl: './avatar-ui.component.html',
  styleUrls: ['./avatar-ui.component.scss'],
  standalone: true,
  imports: [NgOptimizedImage],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.--_avatar-ui-bg-color]': 'this.data().backgroundColor',
    '[style.--_avatar-ui-ft-color]': 'this.data().foregroundColor',
    '[class.with-picture]': 'data()?.pictureURL?.length > 0 && !displayDefaultAvatar()',
  },
})
export default class AvatarUiComponent {
  readonly #avatar = inject(AvatarService);

  readonly avatarInfos = input<AvatarInfos>();

  readonly data = computed<AvatarFullInfos>(() => this.#avatar.getAvatarInfos(this.avatarInfos()));

  readonly displayDefaultAvatar = signal(false);

  onError(): void {
    this.displayDefaultAvatar.set(true);
  }
}
